// src/app/contexts/ExamTypeContext.js
import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { EXAM_TYPES } from 'app/types/examTypes';

const ExamTypeContext = createContext();

export const ExamTypeProvider = ({ children }) => {
  const [examType, setExamType] = useState({ rid_cd_ext: '', name: '' });
  const location = useLocation();

  useEffect(() => {
    // Determine exam type based on URL path
    const currentPath = location.pathname;
    const examTypeEntry = Object.values(EXAM_TYPES).find(type => {
      const pathPattern = new RegExp(`/admin/${type.pathPrefix}(?:/|$)`);
      return pathPattern.test(currentPath);
    });

    if (examTypeEntry) {
      setExamType({
        rid_cd_ext: examTypeEntry.rid_cd_ext,
        name: examTypeEntry.name,
        pathPrefix: examTypeEntry.pathPrefix,
        routeSegments: examTypeEntry.getRouteSegments(currentPath)
      });
    }
  }, [location]);

  const updateExamType = useCallback((newType) => {
    setExamType(newType);
  }, []);

  return (
    <ExamTypeContext.Provider value={{ examType, updateExamType }}>
      {children}
    </ExamTypeContext.Provider>
  );
};

export const useExamType = () => {
  const context = useContext(ExamTypeContext);
  if (!context) {
    throw new Error('useExamType must be used within an ExamTypeProvider');
  }
  return context;
};